import React, { forwardRef, useImperativeHandle } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import api from "../../../config/URL";
import PhoneInput from "react-phone-input-2";

const validationSchema = Yup.object().shape({
  contactNumber: Yup.string()
    .matches(/^\+\d{10,15}$/, "*Invalid Phone Number")
    .required("*Contact Number is required"),

  address: Yup.string().required("*Address is required"),

  postalCode: Yup.string()
    .matches(/^[0-9]+$/, "*Postal Code must contain only numbers")
    .min(4, "*Postal Code must be at least 4 digits")
    .max(6, "*Postal Code can't be longer than 6 digits")
    .required("*Postal Code is required"),
});

const ContactAdd = forwardRef(
  ({ formData, setLoadIndicators, setFormData, handleNext }, ref) => {
    const userName = localStorage.getItem("userName");

    const formik = useFormik({
      initialValues: {
        // email: formData.email,
        contactNumber: formData.contactNumber,
        address: formData.address,
        postalCode: formData.postalCode,
        createdBy: userName,
      },
      validationSchema: validationSchema,
      onSubmit: async (values) => {
        setLoadIndicators(true);
        values.createdBy = userName;
        try {
          const response = await api.post(
            `/createUserContactInfo/${formData.user_id}`,
            values,
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );
          if (response.status === 201 || response.status === 200) {
            toast.success(response.data.message);
            setFormData((prv) => ({ ...prv, ...values }));
            handleNext();
          } else {
            toast.error(response.data.message);
          }
        } catch (error) {
          if (error?.response?.status === 409) {
            toast.warning(error?.response?.data?.message);
          } else {
            toast.error(
              "Error Submiting data ",
              error?.response?.data?.message
            );
          }
        } finally {
          setLoadIndicators(false);
        }
      },
    });

    useImperativeHandle(ref, () => ({
      contactAdd: formik.handleSubmit,
    }));

    return (
      <form onsubmit={formik.handleSubmit}>
        <section>
          <div className="container-fluid">
            <p className="headColor my-4">Contact Information</p>
            <div className="row">
              <div className="col-md-6 col-12 mb-2 mt-3">
                <label>
                  Contact Number<span className="text-danger">*</span>
                </label>
                <PhoneInput
                  country={"sg"}
                  enableSearch={true}
                  inputProps={{
                    name: "contactNumber",
                    required: true,
                    onBlur: formik.handleBlur,
                  }}
                  value={formik.values.contactNumber}
                  onChange={(phone) =>
                    formik.setFieldValue("contactNumber", "+" + phone)
                  }
                  containerClass="phone-input-container"
                  inputClass="phone-input"
                  buttonClass="phone-flag-button"
                />
                {formik.touched.contactNumber &&
                  formik.errors.contactNumber && (
                    <div className="text-danger">
                      <small>{formik.errors.contactNumber}</small>
                    </div>
                  )}
              </div>
              <div className="col-md-6 col-12 mb-2 mt-3">
                <label>
                  Postal Code<span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="postalCode"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.postalCode}
                />
                {formik.touched.postalCode && formik.errors.postalCode && (
                  <div className="error text-danger ">
                    <small>{formik.errors.postalCode}</small>
                  </div>
                )}
              </div>
              <div className="col-md-6 col-12 mb-2 mt-3">
                <label>
                  Address<span className="text-danger">*</span>
                </label>
                <textarea
                  type="text"
                  className="form-control"
                  name="address"
                  rows="3"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.address}
                />
                {formik.touched.address && formik.errors.address && (
                  <div className="error text-danger ">
                    <small>{formik.errors.address}</small>
                  </div>
                )}
              </div>
            </div>
          </div>
        </section>
      </form>
    );
  }
);

export default ContactAdd;
